import { timeLongFormat } from "~/helpers/strings";

export default function BaseRouteCard({
    route: {from, to, date, departDate, departDateFrom, departDateTo, time, departTime, departTimeFrom, departTimeTo, flightTime, flight_time, seats},
    showPlane = false
}) {

    const formatDate = (raw) => {
        if (!window.moment) return raw;
        const m = moment(raw, 'DD.MM.YYYY');
        return m.year() === moment().year() ? m.format("D MMMM") : m.format("D MMM YYYY");
    };
    
    const receivedDate = date || departDate || departDateFrom;
    const dateFrom = formatDate(receivedDate) || receivedDate;
    const timeFrom = time || departTime || departTimeFrom;
    const dateTo = departDateTo ? formatDate(departDateTo) : undefined;
    const timeTo = departTimeTo || undefined;
    const receivedFlightTime = flightTime || flight_time;

    return <React.Fragment>
        <div className="direction-card__header">
            <div className="direction-card__date">
                {`${dateFrom} (${timeFrom}) ${!!dateTo ? '—' : ''}`}
                {!!dateTo && <br/>}
                {!!dateTo && `${dateTo} (${timeTo})`}
            </div>
            <div className="direction-card__time">
                {receivedFlightTime ? timeLongFormat(receivedFlightTime) : ''}
            </div>
            {seats > 0 && <div className="direction-card__user">
                <span>
                    <i className="icon-user"></i>
                    {seats}
                </span>
            </div>}
        </div>
        <div className="direction-card__way">
            <div className="direction-card__code">{from.icao}</div>
            <div className="direction-card__line">
                <span></span>
                <div className="solid-left"></div>
                {!showPlane && <span></span>}
                {showPlane && <i className="icon-plane2"></i>}
                <div className="solid-right"></div>
                <span></span>
            </div>
            <div className="direction-card__code">{to.icao}</div>
        </div>
        <div className="direction-card__city">

            {!!receivedFlightTime && <div className="direction-card__sub">
                {__('search.flight.flightTime')}
            </div>}
            <div className="direction-card__city-from">
                {from.city && <span style={{ marginRight: '5px' }}>{from.city + (from.airport ? ',' : '')}</span>}
                {from.airport && <span>{from.airport}</span>}
            </div>
            <div className="direction-card__city-to">
                {to.city && <span style={{ marginRight: '5px' }}>{to.city + (to.airport ? ', ' : '')}</span>}
                {to.airport && <span>{to.airport}</span>}
            </div>
        </div>
    </React.Fragment>
}
